const strings = {
  deviceDetailModal: {
    batteryPct: (batteryPct: number) =>
      `${batteryPct?.toFixed(0) || "N/a"}% Battery`,
    online: "Online",
    offline: "Offline",
    tankPct: (tankPct: number) => `${tankPct?.toFixed(0) || "N/a"}%`,
    soilMoisture: "Soil Moisture",
    eventsLog: "Events Log",
    locationOfDevice: (deviceName: string) => `Location of ${deviceName}`,
    notes: "Notes",
    editSettings: "Edit Settings",
  },
};

export default strings;
